import React, { useEffect, useState } from "react";
import ContactFrame from "../ContactFrame";
import Vector from "../../../../components/Atomos/Icons/Vector";
import { ContactTypeString } from "../../../../components/Catalogs/FirmContact/FirmContactEnums";
import { formatPersonPhoneForDisplay } from "../../../../utils/formatPhoneForDisplay";

interface JurisdictionMembershipProps {
  jurisdiction?: string;
  contacts?: { type: string; contact: string; id: string }[];
  firm?: string;
  filterBy?: string[];
  persons?: any[];
}

const formatContactType = (type: string): string => {
  return ContactTypeString[type as keyof typeof ContactTypeString];
};

const JurisdictionMembership: React.FC<JurisdictionMembershipProps> = ({
  jurisdiction,
  contacts,
  filterBy,
  persons,
}) => {
  const [contactsWithDetails, setContactsWithDetails] = useState<
    {
      type: string;
      contact: string;
      name?: string;
      phoneNumber?: string;
      firmEmail?: string;
      lastName?: string;
    }[]
  >([]);

  useEffect(() => {
    if (!contacts?.length) {
      setContactsWithDetails([]);
      return;
    }
    const updatedContacts = contacts.map((contact: any) => {
      const personId = contact.id ?? contact.contact;
      const foundPerson =
        personId && (persons ?? []).length > 0
          ? persons?.find((person) => person.id === personId)
          : undefined;
      const displayNameFromApi =
        typeof contact.fullName === "string" && contact.fullName.trim()
          ? contact.fullName.trim()
          : "";

      return {
        ...contact,
        name: foundPerson?.name,
        phoneNumber: formatPersonPhoneForDisplay(foundPerson, contact.phone),
        firmEmail: foundPerson?.firmEmail ?? contact.email ?? "",
        countryCodePhoneNumber: foundPerson?.countryCodePhoneNumber,
        lastName: foundPerson?.lastName,
        displayName:
          displayNameFromApi ||
          [foundPerson?.name, foundPerson?.lastName].filter(Boolean).join(" ").trim(),
      };
    });
    setContactsWithDetails(updatedContacts);
  }, [persons, contacts]);

  return (
    <div className="flex flex-col items-left gap-6">
      <div className="flex flex-row items-center self-stretch gap-4">
        <h2 className="not-italic font-medium text-lg leading-5 text-Default font-decimal">
          {jurisdiction + " Membership"}
        </h2>
        <div className="flex flex-1 ">
          <Vector className="w-full h-0 stroke-gray-50 stroke-1" />
        </div>
      </div>
      <div className="grid grid-cols-6 gap-5">
        {contactsWithDetails
          .sort((a: any, b: any) => {
            if (filterBy && filterBy.length > 0) {
              for (const filter of filterBy ? filterBy : []) {
                if (a[filter] === b[filter]) {
                  continue;
                }
                return a[filter] < b[filter] ? -1 : 1;
              }
            }
            return 0;
          })
          .map((contact, index) => (
            <ContactFrame
              key={index}
              type={formatContactType(contact.type)}
              name={
                (contact as any).displayName?.trim() ||
                [contact.name, contact.lastName].filter(Boolean).join(" ").trim() ||
                "—"
              }
              phone={contact.phoneNumber}
              email={contact.firmEmail}
            />
          ))}
      </div>
    </div>
  );
};

export default JurisdictionMembership;
